// Metodos de pago disponibles en el checkout de la tienda (ver CheckoutPage). Se comparte
// este mapeo de etiquetas con las vistas de administracion (lista y detalle de pedidos).
export const PAYMENT_METHOD_LABELS = {
  tarjeta: 'Tarjeta',
  yape: 'Yape',
  // Solo disponible en la venta express registrada por un administrador (ver
  // ExpressSalePage), no en el checkout publico.
  efectivo: 'Efectivo',
  contra_entrega: 'Contra entrega',
  whatsapp: 'Por WhatsApp',
};

// Metodos de pago inmediato validos para una venta express (ver StoreExpressOrderRequest en
// el backend): a diferencia del checkout, no tiene sentido ofrecer "contra entrega" ni
// "coordinar por WhatsApp" para una venta que el administrador ya esta registrando como hecha.
export const EXPRESS_PAYMENT_METHODS = ['tarjeta', 'yape', 'efectivo'];

export const paymentMethodLabel = (value) => PAYMENT_METHOD_LABELS[value] || '—';
